import htmx, { RequestEvent } from 'htmx.org';
import { on } from 'delegated-events';
import invisibleFocus from '../utils/invisibleFocus';

// Configuration
htmx.config.requestClass = 'is-requesting';
htmx.config.allowEval = false;

on('mousedown', '[data-hx-trigger="click"]', (event) => {
  const { currentTarget } = event;
  invisibleFocus(currentTarget);
});

htmx.on('htmx:beforeRequest', (event) => {
  const { elt } = (event as RequestEvent).detail;
  invisibleFocus(elt);
});
